import { createApi } from "@reduxjs/toolkit/query/react";
import { State } from "@shared/models/State";
import { axiosBaseQuery } from "@shared/utils/request";

import config from "../../config";

export type GetStateListResponse = {
  total: number;
  items: State[];
};

export type GetStateListParams = {
  search?: string;
  page?: number;
  limit?: number;
  order?: string;
  direction?: string;
};

export const stateApi = createApi({
  reducerPath: "stateApi",
  baseQuery: axiosBaseQuery({
    baseUrl: config.baseApiUrl,
  }),
  tagTypes: ["StateList", "State"],
  endpoints: (builder) => ({
    getStateList: builder.query<GetStateListResponse, GetStateListParams>({
      query: (params) => {
        return {
          url: `states`,
          params,
        };
      },
      providesTags: ["StateList"],
    }),
  }),
});

export const { useGetStateListQuery } = stateApi;
